import { render, staticRenderFns } from "./HistoryGame.vue?vue&type=template&id=fbc2419c&scoped=true&"
import script from "./HistoryGame.vue?vue&type=script&lang=js&"
export * from "./HistoryGame.vue?vue&type=script&lang=js&"
import style0 from "./HistoryGame.vue?vue&type=style&index=0&id=fbc2419c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc2419c",
  null
  
)

export default component.exports